import React, { useEffect, useState, useRef } from "react";
import { ethers } from "ethers";

import config from "../config";
const currentConfig = config.polygonmainnet;

const availableNetworks = [5]; // goerli only
const rootChainID = 137;

export const contractInfo = {
  1: {
    Network: "Mainnet",
    MainCardAddress: currentConfig.nftCardAddress,
    MasterAddress: "0x9194c01db602ed716e9d16fa60f684deb3b62523" // squid Master Address
  },
  5: {
    Network: "Goerli Testnet",
    MainCardAddress: currentConfig.nftCardAddress,
    MasterAddress: "0x3338202af08ebd7db74df5fa290563b28e5ce333" // squid Master Address
  },
  137: {
    Network: "Polygon Mainnet",
    MainCardAddress: currentConfig.nftCardAddress,
    MasterAddress: "0x9194c01db602ed716e9d16fa60f684deb3b62523" // squid Master Address
  },

  0: {
    Network: "Undefined",
    MainCardAddress: "",
    MasterAddress: ""
  }
};

export const EthersContext = React.createContext(null);

const EthersProvider = props => {
  const [account, setAccount] = useState("");
  const [networkId, setNetworkId] = useState(0);
  const [verified, setVerified] = useState(true);
  const [initialized, setInitialized] = useState(false);

  const [runwalletconnect, setWalletConnect] = useState(false);

  let provider = useRef(null);
  let signer = useRef(null);
  let accounts = useRef(null);

  // if (typeof window.ethereum === "undefined") {
  //   return (
  //     <div>You need an ethereum wallet extention to play this game ...</div>
  //   );
  // }

  useEffect(() => {
    startApp();
    watchChainAccount();
  }, []);

  useEffect(() => {
    if (runwalletconnect) {
      startApp();
    }
    setWalletConnect(false);
  }, [runwalletconnect]);

  const startApp = async () => {
    try {
      if (!provider.current) {
        provider.current = new ethers.providers.Web3Provider(window.ethereum);
      }
      let chainId = (await provider.current.getNetwork()).chainId;

      if (chainId !== rootChainID) {
        await switchToRootChain();
        chainId = (await provider.current.getNetwork()).chainId;
      }

      let accts = await provider.current.listAccounts();
      if (accts.length <= 0) {
        await connectWallet();
      }

      signer.current = provider.current.getSigner();
      let myacc = await signer.current.getAddress();

      // await watchChainAccount();
      setNetworkId(chainId);
      setAccount(myacc);
      console.log("chainId =>", chainId);
      if (chainId == rootChainID) {
        setInitialized(true);
      }
    } catch (error) {
      // alert(
      //   `Failed to load web3, accounts, or contract. Check console for details.`
      // );
      console.error(error);
    }
  };

  const connectWallet = async () => {
    accounts.current = await window.ethereum.request({
      method: "eth_requestAccounts"
    });
  };

  const watchChainAccount = async () => {
    window.ethereum.on("accountsChanged", accounts => {
      console.log("accountsChanged****");
      startApp();
    });
    window.ethereum.on("chainChanged", chainId => {
      console.log("chainChanged**** chainId => ", chainId);
      if (chainId == rootChainID) {
        setInitialized(true);
      } else {
        setInitialized(false);
      }
      setNetworkId(chainId);
      // window.location.reload();
      startApp();
      // alert("Network changed to " + contractInfo[parseInt(chainId)].Network);
    });
    // provider.current.on("connect", (connectInfo) => {
    //   alert("Connected to Ethereum network");
    // });
    window.ethereum.on("disconnect", error => {
      // alert("Disconnected from Ethereum network");
      console.log(error);
    });
  };

  const switchToRootChain = async () => {
    try {
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x" + rootChainID.toString(16) }]
      });
    } catch (switchError) {
      if (switchError.code === 4902) {
        addChainToWallet();
      }
      // alert(`Add the network ${rootChainID} into your wallet`);
    }

    provider.current = new ethers.providers.Web3Provider(window.ethereum);
  };

  const addChainToWallet = async () => {
    const POLYGON_CHAIN_NAME = "Matic Polygon Mainnet";
    const POLYGON_TOKEN_NAME = "Matic Token";
    const POLYGON_SYMBOL = "MATIC";
    const POLYGON_DECIMAL = 18;
    const POLYGON_RPC_URL = "https://polygon-rpc.com/";
    const POLYGON_BLOCK_EXPLORER = "https://polygonscan.com";

    const params = {
      chainId: "0x" + rootChainID.toString(16), // A 0x-prefixed hexadecimal string
      chainName: POLYGON_CHAIN_NAME, //"Matic Polygon Mainnet",
      nativeCurrency: {
        name: POLYGON_TOKEN_NAME, //"Matic Token",
        symbol: POLYGON_SYMBOL, //"MATIC", // 2-6 characters long
        decimals: POLYGON_DECIMAL //18,
      },
      rpcUrls: [POLYGON_RPC_URL], // ["https://polygon-rpc.com/"],
      blockExplorerUrls: [POLYGON_BLOCK_EXPLORER] //["https://polygonscan.com"],
    };

    try {
      await _ethereum.request({
        method: "wallet_addEthereumChain",
        params: [params, account]
      });
    } catch (addError) {
      console.log("Netword add failed... =>", addError);
      // Netword add failed...
    }
  };

  const contextValues = {
    provider,
    signer,
    account,
    setAccount,
    networkId,
    setNetworkId,
    verified,
    setVerified,
    initialized,
    setWalletConnect
  };

  return (
    // if (!this.state.loaded) {
    //   return <div>Change your wallet network into Goerli testnet and press F5 ...</div>;
    // }
    // return (

    <>
      <EthersContext.Provider value={contextValues}>
        {props.children}
      </EthersContext.Provider>
    </>
  );
};
export default EthersProvider;
